import { DeviceDTO } from '@eppendorf/vnls-device-service-utils';
import { Icon, IconSizeClasses } from '@eppendorf/vnls-react-components';
import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

import { useDeviceType } from '$components/app-config/useDeviceType';
import { searchDeviceIcon } from '$features/devices/devices.utils';

export function DeviceTypeCell({
  device,
  withModel = false,
}: {
  device: DeviceDTO | null;
  withModel?: boolean;
}): ReactElement {
  const deviceType = useDeviceType(device)?.toLowerCase();
  const { t } = useTranslation();

  return (
    <div className="device-type-cell">
      <Icon
        size={IconSizeClasses.Small}
        name={searchDeviceIcon(deviceType as string, undefined, device?.model)}
      />
      <div className="device-type-cell_content">
        <div className="device-type-cell__label-type">
          {/* eslint-disable-next-line @typescript-eslint/no-explicit-any -- we know it exists */}
          {t(`deviceType.${deviceType}` as any)}
        </div>
        {withModel && (
          <div className="device-type-cell__label-model">
            {device?.manufacturer} {device?.model}
          </div>
        )}
      </div>
    </div>
  );
}
